/**
 * @file graphql/driver.ts
 * queries/mutations for Driver.
 *
 */

import { gql } from "@apollo/client";

export const LOAD_DRIVER = gql`
  query Driver($id: ID!) {
    node(id: $id) {
      id
      ... on Driver {
        id
        firstName
        lastName
        mobilePhone
        homePhone
        homeAddress
        email
        licenseNumber
        licenseClass
        licenseState
        licenseExpirationDate
        note
        driverProfilePhoto
        operator {
          id
          name
          nameSlug
          plan
          moovsMarketApps {
            id
            driverApp {
              id
              active
            }
          }
        }
      }
    }
  }
`;

export const CREATE_DRIVER_SCHEDULE_SETTING_AND_EVENTS_MUTATION = gql`
  mutation CreateDriverScheduleSettingAndEvents(
    $input: CreateDriverScheduleSettingAndEventsInput!
  ) {
    createDriverScheduleSettingAndEvents(input: $input) {
      result {
        __typename
        ... on CreateDriverScheduleSettingAndEventsSuccess {
          driverScheduleSetting {
            id
            scheduleType
          }
        }
        ... on CreateDriverScheduleSettingAndEventsFailure {
          reason
        }
      }
    }
  }
`;

export const LOAD_DRIVER_SCHEDULE_EVENTS = gql`
  query LoadDriverScheduleEvents($driverId: String!) {
    loadDriverScheduleEvents(driverId: $driverId) {
      id
      startDateTime
      endDateTime
      scheduleType
      driverScheduleSetting {
        id
        daysToRepeat
      }
    }
  }
`;

export const REMOVE_DRIVER_SCHEDULE_SETTING_AND_EVENTS_MUTATION = gql`
  mutation RemoveDriverScheduleSettingAndEvents(
    $input: RemoveDriverScheduleSettingAndEventsInput!
  ) {
    removeDriverScheduleSettingAndEvents(input: $input) {
      driverScheduleSetting {
        id
      }
    }
  }
`;
